
    import '/home/ec2-user/Youlify-Design/components/layout/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["layout-demo-basic","layout-demo-top","layout-demo-top-side","layout-demo-top-side-2","layout-demo-side","layout-demo-custom-trigger","layout-demo-responsive","layout-demo-fixed","layout-demo-fixed-sider","layout-demo-custom-trigger-debug","layout-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/layout/index.en-US.md?type=demo')
};